export default "__VITE_ASSET__DqFj75Rp__ 120w, __VITE_ASSET__BRN4o4Ky__ 240w, __VITE_ASSET__DenOVBZh__ 480w, __VITE_ASSET__BU3QxB1Q__ 512w";